import styled from "styled-components";

import iodineIcon from "../../../../assets/Mayo/iodine.svg";

export default function IodineWarning() {
  return (
    <Container>
      <IodineIcon src={iodineIcon} />
      <Text>
        If you’re allergic to iodine, please contact us.
      </Text>
    </Container>
  );
}

const Container = styled.div`
  margin-inline: 26px;
  border: 2px solid #F02A4C;
  border-radius: 15px;
  padding: 22px 44px 22px 22px;

  display: flex;
  gap: 12px;
`

const IodineIcon = styled.img`
  height: 25px;
  width: 21px;
`

const Text = styled.p`
  margin: 0;
  font-size: 19px;
  color: #000000;
  font-weight: 500;
`